// UTM field constants and pure helpers shared between LeadPipelineCard
// (component) and normalizeContactPayload (save-boundary utility).
//
// Extracted from LeadPipelineCard to keep the dependency direction correct:
// utilities should not import from components.  Both LeadPipelineCard and
// normalizeContactPayload import from this module instead.

export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

/**
 * Trims whitespace and converts empty strings to null so the backend stores
 * null (not "") for empty UTMs.
 *
 * @param {string|null|undefined} v - the raw UTM value
 * @returns {string|null} the trimmed value, or null if empty/whitespace-only
 */
export function trimUtmValue(v) {
    return v == null ? v : (String(v).trim() || null);
}

/**
 * Build the set of changed UTM fields by comparing draft values against the
 * current contact.  Shared by the dirty-check (utmDirty) and the saveUtms
 * changes-builder so the trim+compare logic is not duplicated.
 *
 * @param {Object} drafts - the draft state (utmDrafts or editForm)
 * @param {Object} contact - the current contact record
 * @returns {Object} a map of { utm_key: normalised_value } for changed fields
 */
export function buildUtmChanges(drafts, contact) {
    const changes = {};
    UTM_KEYS.forEach(k => {
        if (!(k in drafts)) return;
        const d = String(drafts[k] ?? '').trim();
        const cur = String(contact[k] ?? '').trim();
        if (d !== cur) changes[k] = trimUtmValue(drafts[k]);
    });
    return changes;
}
